document.addEventListener('DOMContentLoaded', function () {

  // ── 1. Reveal produit (comportement existant) ──────────────────
  const mediaGallery = document.querySelector('[id*="media-gallery"]');
  const productDetails = document.querySelector('.product-details');

  if (mediaGallery && productDetails) {
    console.log('Media reveal: page produit détectée');

    mediaGallery.style.opacity = '0';
    mediaGallery.style.transform = 'translateY(30px)';
    mediaGallery.style.filter = 'blur(10px)';
    mediaGallery.style.transition = 'opacity 1.8s, transform 1.8s, filter 2.8s';

    productDetails.addEventListener('click', function (e) {
      const clickedIcon = e.target.closest('.icon-block');
      if (!clickedIcon) return;
      setTimeout(function () {
        mediaGallery.style.opacity = '1';
        mediaGallery.style.transform = 'translateY(0)';
        mediaGallery.style.filter = 'blur(0px)';
      }, 300);
    }, true);
  }

  // ── 2. Reveal scroll — texte enrichi section blog ──────────────
  const richText = document.querySelector(
    '#shopify-section-template--27726429651326__section_6egG9P'
  );

  if (richText) {
    console.log('Media reveal: bloc texte enrichi détecté');

    richText.style.opacity = '0';
    richText.style.transform = 'translateY(32px)';
    richText.style.filter = 'blur(6px)';
    richText.style.transition = 'opacity 1.2s ease, transform 1.2s ease, filter 1.6s ease';


var observer = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      // Petit délai pour laisser le style initial s'appliquer
      setTimeout(function () {
        entry.target.style.opacity = '1';
        entry.target.style.filter = 'blur(0px)';
        entry.target.style.transform = 'translateY(0)';
      }, 100);
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    observer.observe(richText);
  } else {
    console.log('Éléments non trouvés');
  }

});
